import useResources from "./use-resources";
import type { MCPToken, CreatedTokenResponse } from "../models/mcpToken";

const ROOT_PATH = "account/mcp-tokens";

export interface CreateTokenInput {
  name: string;
  scopes: string[];
  expires_days?: number;
}

export default function useMCPTokens() {
  const { resources, error, isLoading, mutate, axios } =
    useResources<MCPToken>(ROOT_PATH);

  async function createToken(
    input: CreateTokenInput,
  ): Promise<CreatedTokenResponse> {
    const response = await axios.post(ROOT_PATH, input);
    await mutate();
    return response.data;
  }

  // Revoking soft-deletes: the token stays listed with `revoked_at` set, so we
  // revalidate rather than optimistically removing it from the list.
  async function revokeToken(tokenId: number) {
    await axios.delete(`${ROOT_PATH}/${tokenId}`);
    await mutate();
  }

  return {
    tokens: resources,
    error,
    isLoading,
    createToken,
    revokeToken,
  };
}
